















































































































































import { Component, InjectReactive, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { Dictionary } from "vue-router/types/router";
import { Form as ElForm, Input } from "element-ui";
import { UserModule } from "@/store/modules/user";
import { isValidUsername } from "@/utils/validate";
import { login, logout, gettoken } from "@/api/users";
// 引入图片验证码组件
import SIdentify from "@/components/identify/index.vue";
@Component({
  name: "Login",
  components: {
    SIdentify,
  },
})
export default class extends Vue {
  private imgurl = require("@/assets/loginimage/logo1@2x.png");
  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (value === '' || value === undefined) {
      callback(new Error("请输入用户名"));
    } else {
      callback();
    }
  };
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length === 0) {
      callback(new Error("请输入密码"));
    } else {
      callback();
    }
  };

  //andy 图片验证码
  private identifyCode = '';
  //andy 验证码规则
  private identifyCodes = '3456789ABCDEFGHGKMNPQRSTUVWXY';

  private validateIdentify = (rule: any, value: string, callback: Function) => {
    if (value.length === 0) {
      callback(new Error("请输入验证码"));
    } else {
      callback();
    }
  };
  private loginForm = {
    loginName: "",
    pwd: "",
    role: 0,
    identify: "",
  };
  private loginRules = {
    loginName: [{ validator: this.validateUsername, trigger: "blur" }],
    pwd: [{ validator: this.validatePassword, trigger: "blur" }],
    identify: [{ validator: this.validateIdentify, trigger: "blur" }],
  };
  private passwordType = "password";
  private loading = false;
  private showDialog = false;
  private redirect?: string;
  private otherQuery: Dictionary<string> = {};
  

  @Watch("$route", { immediate: true })
  private onRouteChange(route: Route) {
    const query = route.query as Dictionary<string>;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }

  mounted() {
    this.refreshCode()
    // if (this.loginForm.loginname === "") {
    //   // (this.$refs.loginname as Input).focus();
    // } else if (this.loginForm.password === "") {
    //   // (this.$refs.password as Input).focus();
    // }
  }

  //andy 切换验证码
  private  refreshCode() {
    this.identifyCode = ''
    this.makeCode(this.identifyCodes, 4)
  }
  //andy 生成随机验证码
  private makeCode(o, l) {
    for (let i = 0; i < l; i++) {
      this.identifyCode += this.identifyCodes[
      Math.floor(Math.random() * (this.identifyCodes.length - 0) + 0)
      ]
    }
  }

  private showPwd() {
    if (this.passwordType === "password") {
      this.passwordType = "";
    } else {
      this.passwordType = "password";
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus();
    });
  }
  private hrefopen() {
    window.open("http://www.tellyes.com/");
  }
  private handleLogin() {
    if (this.loginForm.identify.toUpperCase() !== this.identifyCode) {
      this.$message.warning("请输入正确的验证码");
      return false;
    }
    (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        //await UserModule.Login(this.loginForm);
        await gettoken(this.loginForm).then((res) => {
          if (res.code === 200) {
            // let json = {
            //   usertype: res.data.usertype,
            //   userid: res.data.userid,
            //   orgnizeid: res.data.orgnizeid,
            //   name: res.data.name,
            //   createduserid: res.data.createduserid,
            // };

            window.sessionStorage.setItem("token", res.data.token)
            window.sessionStorage.setItem("name", this.loginForm.loginName)
            window.sessionStorage.setItem("id", res.data.id)
            window.sessionStorage.setItem("role", res.data.role)
            console.log(res.data.role === 3)
            if (res.data.role === 0) {
              this.$router.push({ path: "/tissuemanage/tissuemanage" })
            } else if (res.data.role === 3) {
              this.$router.push({ path: "/expertManage/expertManage" })
            }
            // let item: any = window.sessionStorage.getItem("json");
            // let isuser = JSON.parse(item).orgnizeid === "";
            // // 用户组织id为空，游客登录  用户组织不为空，管理员登录
            // if (!isuser) {
            //   this.$router.push({ path: "/tissuemanage/tissuemanage" });
            // } else {
            //   this.$router.push({ path: "/userinfo/userinfo" });
            // }
            // this.$router.push({
            //   path: this.redirect || "/",
            //   query: this.otherQuery,
            // });
          } else {
            this.$message.warning("登录错误,请确认用户名和密码");
          }
        });
        // this.$router.push({
        //   path: this.redirect || "/",
        //   // path: "/",
        //   query: this.otherQuery,
        // });
        // // Just to simulate the time of the request
        setTimeout(() => {
          this.loading = false;
        }, 0.5 * 1000);
      } else {
        return false;
      }
    });
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== "redirect") {
        acc[cur] = query[cur];
      }
      return acc;
    }, {} as Dictionary<string>);
  }
}
